import EditMyUHLParcelContainer from "../containers/EditMyUHLParcelContainer";

const EditMyUHLParcelPage = () => {
    return <EditMyUHLParcelContainer />;
};

export default EditMyUHLParcelPage;
